module.exports = __webpack_public_path__ + "static/img/5.46d3d14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/5.png
// module id = bj4H
// module chunks = 0